'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TwitterProxyClient = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _CommonProtocolClient = require('./CommonProtocolClient.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterProxyClient = exports.TwitterProxyClient = function () {
	function TwitterProxyClient(_ref) {
		var XMLHttpRequest = _ref.XMLHttpRequest,
		    _ref$endpointUrl = _ref.endpointUrl,
		    endpointUrl = _ref$endpointUrl === undefined ? 'https://apps.wixrestaurants.com/twitter/' : _ref$endpointUrl,
		    _ref$timeout = _ref.timeout,
		    timeout = _ref$timeout === undefined ? 0 : _ref$timeout;
		(0, _classCallCheck3.default)(this, TwitterProxyClient);

		this._client = new _CommonProtocolClient.CommonProtocolClient({ XMLHttpRequest: XMLHttpRequest, endpointUrl: endpointUrl, timeout: timeout });
	}

	(0, _createClass3.default)(TwitterProxyClient, [{
		key: 'api',
		value: function api(_ref2) {
			var path = _ref2.path,
			    params = _ref2.params;

			return this._client.doRequest('api', { path: path, params: params });
		}
	}]);
	return TwitterProxyClient;
}();